"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTertiaryInlineVariantStyles = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _utils2 = require("../utils");
var _constants = require("./constants");
var _variantStyles = require("./variantStyles");
const getTertiaryInlineVariantStyles = _ref => {
  let {
    isDestructive,
    isDisabled,
    hasUnderline,
    iconOnly
  } = _ref;
  const tokenSuffix = isDisabled ? 'disabled' : 'default';
  const commonStyles = {
    borderColor: _constants.TRANSPARENT_COLOR,
    display: 'inline-flex',
    backgroundColor: _constants.TRANSPARENT_COLOR,
    textDecoration: hasUnderline ? 'underline' : 'none',
    borderRadius: iconOnly ? (0, _utils.token)('dimensions.border.radius.round') : (0, _utils.token)('dimensions.border.radius.100'),
    // min size should be same for both default and small
    minHeight: _utils2.A11Y_INLINE_MIN_SIZE,
    minWidth: _utils2.A11Y_INLINE_MIN_SIZE,
    padding: (0, _utils.token)('dimensions.spacing.none')
  };
  let restStyles = {
    color: (0, _utils.token)("color.link.primary-".concat(tokenSuffix)),
    ...commonStyles
  };
  let stateStyles = (0, _variantStyles.getStateStylesWithOutlineOnFocus)({
    'focus-visible': {},
    hover: {
      color: (0, _utils.token)('color.link.primary-hover'),
      textDecoration: hasUnderline ? 'none' : 'underline'
    },
    active: {
      color: (0, _utils.token)('color.link.primary-pressed')
    }
  }, (0, _utils.token)('color.border.border-focus'), restStyles.backgroundColor);
  if (isDestructive) {
    restStyles = {
      color: (0, _utils.token)("color.link.critical-".concat(tokenSuffix)),
      ...commonStyles
    };
    stateStyles = (0, _variantStyles.getStateStylesWithOutlineOnFocus)({
      'focus-visible': {},
      hover: {
        color: (0, _utils.token)('color.link.critical-hover'),
        textDecoration: hasUnderline ? 'none' : 'underline'
      },
      active: {
        color: (0, _utils.token)('color.link.critical-pressed')
      }
    }, (0, _utils.token)('color.border.border-focus'), restStyles.backgroundColor);
  }
  if (isDisabled) {
    stateStyles = (0, _variantStyles.getStateStylesWithOutlineOnFocus)({
      active: {},
      'focus-visible': {},
      hover: {}
    }, (0, _utils.token)('color.border.border-focus'), restStyles.backgroundColor);
  }
  return {
    ...restStyles,
    ...stateStyles
  };
};
exports.getTertiaryInlineVariantStyles = getTertiaryInlineVariantStyles;